// Angular
import { NgModule, NO_ERRORS_SCHEMA, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Http } from '@angular/http';

// Third party
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { SelectModule } from "angular2-select";
import { InfiniteScrollModule } from "angular2-infinite-scroll";
import { MultiselectDropdownModule } from "angular-2-dropdown-multiselect";
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { Ng2OrderModule } from 'ng2-order-pipe';
import { MyDatePickerModule } from 'mydatepicker';
import { PipeModule } from '../common/pipe/pipe.module';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { CRMModule } from '../crm/crm.module';
import { FooterComponent } from '../common/components/footer/footer.component';
import { TopBarComponent } from '../menus/top-bar/top-bar.component';

// EwApps
@NgModule({
  imports: [
    // Default angular modules 
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    // EwApps moduels 
    PipeModule.forRoot(),
    HomeRoutingModule,       

    // Third party modules 
    NgbModule.forRoot(), 
    SelectModule,
    Ng2OrderModule,
    InfiniteScrollModule,
    MultiselectDropdownModule,
    Ng2SearchPipeModule,
    MyDatePickerModule
  ],
  declarations: [   
    FooterComponent,    
    HomeComponent,
    TopBarComponent
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class HomeModule implements OnInit {

  constructor() {
   
  }

  ngOnInit() {
   
  }
}



// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/home/home.module.ts